// userPasswordSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

// AsyncThunk to send forgot password email
export const forgotPassword = createAsyncThunk(
  'userPassword/forgotPassword',
  async ({ email, grecaptcha }, thunkAPI) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post('/api/users/fpw', { email, grecaptcha }, config)
      return data
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      )
    }
  }
)

// AsyncThunk to reset password
export const resetPassword = createAsyncThunk(
  'userPassword/resetPassword',
  async ({ token, newPassword }, thunkAPI) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post(`/api/users/resetpw/${token}`, { newPassword }, config)
      return data
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      )
    }
  }
)

const userPasswordSlice = createSlice({
  name: 'userPassword',
  initialState: {
    loading: false,
    successForgot: false,
    successReset: false,
    error: null,
  },
  reducers: {
    resetPasswordState: (state) => {
      state.loading = false
      state.successForgot = false
      state.successReset = false
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Forgot password flow
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true
      })
      .addCase(forgotPassword.fulfilled, (state) => {
        state.loading = false
        state.successForgot = true
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Reset password flow
      .addCase(resetPassword.pending, (state) => {
        state.loading = true
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.loading = false
        state.successReset = true
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { resetPasswordState } = userPasswordSlice.actions
export default userPasswordSlice.reducer
